module.exports = __webpack_public_path__ + "d774d12b841bd3daf5a42371fc8e16b5.png";